import { FUSION_THEMES as a } from "@ps/web-fusion-components/themes";
import { z as S } from "zod/v4-mini";
const C = S.enum(a), c = S.literal(["light", "dark"]);
var i = /* @__PURE__ */ ((_) => (_.AccessToken = "spade_accessToken", _.Brand = "X-PS-BRAND", _.Currency = "CURR", _.Env = "X-PS-ENV", _.InstallId = "spade_installId", _.Locale = "NEXT_LOCALE", _.ThemeVariant = "X-PS-THEME-VARIANT", _))(i || {}), l = /* @__PURE__ */ ((_) => (_.GET_TOURNAMENTS_PER_TICKET = "PS_Q_GET_TICKET_TOURNS2", _.GET_TOURNAMENT_TICKETS = "PS_Q_GET_TICKET_COUNTS", _.RESOLVER_TAG = "MSG_RESOLVER_TAG_SRV", _))(l || {}), d = /* @__PURE__ */ ((_) => (_.Brand = "x-ps-brand", _.Device = "x-ps-device", _.Embedded = "x-ps-embedded", _.GeoCountry = "x-ps-geo-country", _.Internal = "x-ps-internal", _.OSFamily = "x-ps-os-family", _.PlayMoney = "x-ps-play-money", _.RequestMock = "x-ps-request-mock", _.Site = "x-ps-site", _.Theme = "x-ps-theme", _.XForwardedFor = "x-forwarded-for", _))(d || {}), t = /* @__PURE__ */ ((_) => (_.HelpGamesAllInRules = "tempest_sidecar_rules", _.HelpGamesHoldemRules = "help_games_holdem", _.HelpGamesOmahaRules = "help_games_omaha", _))(t || {}), P = /* @__PURE__ */ ((_) => (_[_.TournGroup_None = 0] = "TournGroup_None", _[_.TournGroup_DailyMarathon = 1] = "TournGroup_DailyMarathon", _[_.TournGroup_Daily500 = 2] = "TournGroup_Daily500", _[_.TournGroup_Knockouts = 3] = "TournGroup_Knockouts", _[_.TournGroup_BountyBuilders = 4] = "TournGroup_BountyBuilders", _[_.TournGroup_BubbleRush = 5] = "TournGroup_BubbleRush", _[_.TournGroup_Fifty50 = 6] = "TournGroup_Fifty50", _[_.TournGroup_MultiStack = 7] = "TournGroup_MultiStack", _[_.TournGroup_Phased = 8] = "TournGroup_Phased", _[_.TournGroup_JumboShrimp = 9] = "TournGroup_JumboShrimp", _[_.TournGroup_Shootouts = 10] = "TournGroup_Shootouts", _[_.TournGroup_Splash = 11] = "TournGroup_Splash", _[_.TournGroup_TimeTourneys = 12] = "TournGroup_TimeTourneys", _[_.TournGroup_WinTheButton = 13] = "TournGroup_WinTheButton", _[_.TournGroup_TripleThreat = 14] = "TournGroup_TripleThreat", _[_.TournGroup_ThursdayThrill = 15] = "TournGroup_ThursdayThrill", _[_.TournGroup_FatThursday = 16] = "TournGroup_FatThursday", _[_.TournGroup_SuperTuesday = 17] = "TournGroup_SuperTuesday", _[_.TournGroup_FastFriday = 18] = "TournGroup_FastFriday", _[_.TournGroup_DoubleDuece = 19] = "TournGroup_DoubleDuece", _[_.TournGroup_TurboSeries = 20] = "TournGroup_TurboSeries", _[_.TournGroup_Omania = 21] = "TournGroup_Omania", _[_.TournGroup_TheHotTurbos = 22] = "TournGroup_TheHotTurbos", _[_.TournGroup_TheDailyBigs = 23] = "TournGroup_TheDailyBigs", _[_.TournGroup_SundayBillion = 24] = "TournGroup_SundayBillion", _[_.TournGroup_SundayMillion = 25] = "TournGroup_SundayMillion", _[_.TournGroup_SundayWarmUp = 26] = "TournGroup_SundayWarmUp", _[_.TournGroup_SundayStorm = 27] = "TournGroup_SundayStorm", _[_.TournGroup_SundayKickoff = 28] = "TournGroup_SundayKickoff", _[_.TournGroup_SundaySupersonic = 29] = "TournGroup_SundaySupersonic", _[_.TournGroup_SundayShowdown = 30] = "TournGroup_SundayShowdown", _[_.TournGroup_SaturdayMicro = 31] = "TournGroup_SaturdayMicro", _[_.TournGroup_SaturdayEliminator = 32] = "TournGroup_SaturdayEliminator", _[_.TournGroup_SaturdaySplash = 33] = "TournGroup_SaturdaySplash", _[_.TournGroup_SaturdayKO = 34] = "TournGroup_SaturdayKO", _[_.TournGroup_SaturdayDuel = 35] = "TournGroup_SaturdayDuel", _[_.TournGroup_SaturdaySpeedway = 36] = "TournGroup_SaturdaySpeedway", _[_.TournGroup_WomensSunday = 37] = "TournGroup_WomensSunday", _[_.TournGroup_WCOOP = 38] = "TournGroup_WCOOP", _[_.TournGroup_SCOOP = 39] = "TournGroup_SCOOP", _[_.TournGroup_PacificRimSpecial = 40] = "TournGroup_PacificRimSpecial", _[_.TournGroup_MicroMadness = 41] = "TournGroup_MicroMadness", _[_.TournGroup_SaturdaySlam = 42] = "TournGroup_SaturdaySlam", _[_.TournGroup_SaturdayRebuy = 43] = "TournGroup_SaturdayRebuy", _[_.TournGroup_SaturdaySpider = 44] = "TournGroup_SaturdaySpider", _[_.TournGroup_SaturdayScuffle = 45] = "TournGroup_SaturdayScuffle", _[_.TournGroup_SundayStarter = 46] = "TournGroup_SundayStarter", _[_.TournGroup_SundaySlam = 47] = "TournGroup_SundaySlam", _[_.TournGroup_SundayMarathon = 48] = "TournGroup_SundayMarathon", _[_.TournGroup_SundayRebuy = 49] = "TournGroup_SundayRebuy", _[_.TournGroup_SundayHighRoller = 50] = "TournGroup_SundayHighRoller", _[_.TournGroup_Sunday500 = 51] = "TournGroup_Sunday500", _[_.TournGroup_SundayStack = 52] = "TournGroup_SundayStack", _[_.TournGroup_SundayCooldown = 53] = "TournGroup_SundayCooldown", _[_.TournGroup_SundayWrapUp = 54] = "TournGroup_SundayWrapUp", _[_.TournGroup_SundaySpecial = 55] = "TournGroup_SundaySpecial", _[_.TournGroup_SundayHORSE = 56] = "TournGroup_SundayHORSE", _[_.TournGroup_High_Roller_Club = 57] = "TournGroup_High_Roller_Club", _[_.TournGroup_Sunday_Million_Anniversary = 58] = "TournGroup_Sunday_Million_Anniversary", _[_.TournGroup_Sunday_Storm_Anniversary = 59] = "TournGroup_Sunday_Storm_Anniversary", _[_.TournGroup_MicroMillions = 60] = "TournGroup_MicroMillions", _[_.TournGroup_Battle_Royale = 61] = "TournGroup_Battle_Royale", _[_.TournGroup_Monday_6Max = 62] = "TournGroup_Monday_6Max", _[_.TournGroup_Fat_Tuesday = 63] = "TournGroup_Fat_Tuesday", _[_.TournGroup_All_In_Shootout = 64] = "TournGroup_All_In_Shootout", _[_.TournGroup_Micro_Series = 65] = "TournGroup_Micro_Series", _[_.TournGroup_SECOOP = 66] = "TournGroup_SECOOP", _[_.TournGroup_NJSCOOP = 67] = "TournGroup_NJSCOOP", _[_.TournGroup_NJCOOP = 68] = "TournGroup_NJCOOP", _[_.TournGroup_ICOOP = 69] = "TournGroup_ICOOP", _[_.TournGroup_KO_Fever = 70] = "TournGroup_KO_Fever", _[_.TournGroup_Nightly_Stars = 71] = "TournGroup_Nightly_Stars", _[_.TournGroup_Change_Up = 72] = "TournGroup_Change_Up", _[_.TournGroup_Moonlight_Express = 73] = "TournGroup_Moonlight_Express", _[_.TournGroup_Galactic_Series = 74] = "TournGroup_Galactic_Series", _[_.TournGroup_Sunday_Storm_Rebuy = 75] = "TournGroup_Sunday_Storm_Rebuy", _[_.TournGroup_The_Storm_Rebuy = 76] = "TournGroup_The_Storm_Rebuy", _[_.TournGroup_Super_Thursday_Storm = 77] = "TournGroup_Super_Thursday_Storm", _[_.TournGroup_SuperStack = 78] = "TournGroup_SuperStack", _[_.TournGroup_Jab = 79] = "TournGroup_Jab", _[_.TournGroup_Hook = 80] = "TournGroup_Hook", _[_.TournGroup_Uppercut = 81] = "TournGroup_Uppercut", _[_.TournGroup_Ultra_KO = 82] = "TournGroup_Ultra_KO", _[_.TournGroup_Afternoon_on_Stars = 83] = "TournGroup_Afternoon_on_Stars", _[_.TournGroup_El_Clasico = 84] = "TournGroup_El_Clasico", _[_.TournGroup_O_Clasico = 85] = "TournGroup_O_Clasico", _[_.TournGroup_Super_Thursday = 86] = "TournGroup_Super_Thursday", _[_.TournGroup_Super_Thursday_Uppercut = 87] = "TournGroup_Super_Thursday_Uppercut", _[_.TournGroup_Super_Thursday_Bigger = 88] = "TournGroup_Super_Thursday_Bigger", _[_.TournGroup_Super_Thursday_Night_on_Stars = 89] = "TournGroup_Super_Thursday_Night_on_Stars", _[_.TournGroup_Super_Thursday_6th_Sense = 90] = "TournGroup_Super_Thursday_6th_Sense", _[_.TournGroup_Super_Thursday_Hot_BigStack_Turbo = 91] = "TournGroup_Super_Thursday_Hot_BigStack_Turbo", _[_.TournGroup_Super_Thursday_Omaha = 92] = "TournGroup_Super_Thursday_Omaha", _[_.TournGroup_Super_Thursday_Midnight_Express = 93] = "TournGroup_Super_Thursday_Midnight_Express", _[_.TournGroup_Super_Monday = 94] = "TournGroup_Super_Monday", _[_.TournGroup_Super_Monday_Uppercut = 95] = "TournGroup_Super_Monday_Uppercut", _[_.TournGroup_Super_Monday_Bigger = 96] = "TournGroup_Super_Monday_Bigger", _[_.TournGroup_Super_Monday_Night_on_Stars = 97] = "TournGroup_Super_Monday_Night_on_Stars", _[_.TournGroup_Super_Monday_6th_Sense = 98] = "TournGroup_Super_Monday_6th_Sense", _[_.TournGroup_Super_Monday_Hot_BigStack_Turbo = 99] = "TournGroup_Super_Monday_Hot_BigStack_Turbo", _[_.TournGroup_Super_Monday_Omaha = 100] = "TournGroup_Super_Monday_Omaha", _[_.TournGroup_Super_Monday_Midnight_Express = 101] = "TournGroup_Super_Monday_Midnight_Express", _[_.TournGroup_Sunday_6Max = 102] = "TournGroup_Sunday_6Max", _[_.TournGroup_Sunday_Omaha_HiLo = 103] = "TournGroup_Sunday_Omaha_HiLo", _[_.TournGroup_Sunday_Omaha = 104] = "TournGroup_Sunday_Omaha", _[_.TournGroup_Sunday_Evening = 105] = "TournGroup_Sunday_Evening", _[_.TournGroup_Sunday_Full_KO = 106] = "TournGroup_Sunday_Full_KO", _[_.TournGroup_Sunday_Special_Knockout = 107] = "TournGroup_Sunday_Special_Knockout", _[_.TournGroup_Sunday_Challenge = 108] = "TournGroup_Sunday_Challenge", _[_.TournGroup_Sunday_Micro = 109] = "TournGroup_Sunday_Micro", _[_.TournGroup_Sunday_Zoom = 110] = "TournGroup_Sunday_Zoom", _[_.TournGroup_Sunday_Mini = 111] = "TournGroup_Sunday_Mini", _[_.TournGroup_6Max_Club = 112] = "TournGroup_6Max_Club", _[_.TournGroup_Full_KO = 113] = "TournGroup_Full_KO", _[_.TournGroup_EPT = 114] = "TournGroup_EPT", _[_.TournGroup_EPT_Prague = 115] = "TournGroup_EPT_Prague", _[_.TournGroup_EPT_Sochi = 116] = "TournGroup_EPT_Sochi", _[_.TournGroup_EPT_Monte_Carlo = 117] = "TournGroup_EPT_Monte_Carlo", _[_.TournGroup_EPT_Barcelona = 118] = "TournGroup_EPT_Barcelona", _[_.TournGroup_PCA = 119] = "TournGroup_PCA", _[_.TournGroup_Macau_Poker_Cup = 120] = "TournGroup_Macau_Poker_Cup", _[_.TournGroup_APPT = 121] = "TournGroup_APPT", _[_.TournGroup_APPT_Manila = 122] = "TournGroup_APPT_Manila", _[_.TournGroup_APPT_Macau = 123] = "TournGroup_APPT_Macau", _[_.TournGroup_APPT_Korea = 124] = "TournGroup_APPT_Korea", _[_.TournGroup_PokerStars_MEGASTACK = 125] = "TournGroup_PokerStars_MEGASTACK", _[_.TournGroup_MEGASTACK_UK_Ireland = 126] = "TournGroup_MEGASTACK_UK_Ireland", _[_.TournGroup_MEGASTACK_London = 127] = "TournGroup_MEGASTACK_London", _[_.TournGroup_MEGASTACK_Dublin = 128] = "TournGroup_MEGASTACK_Dublin", _[_.TournGroup_MEGASTACK_France = 129] = "TournGroup_MEGASTACK_France", _[_.TournGroup_MEGASTACK_GujanMestras = 130] = "TournGroup_MEGASTACK_GujanMestras", _[_.TournGroup_MEGASTACK_Le_Grande_Motte = 131] = "TournGroup_MEGASTACK_Le_Grande_Motte", _[_.TournGroup_MEGASTACK_Italy = 132] = "TournGroup_MEGASTACK_Italy", _[_.TournGroup_MEGASTACK_Sanremo = 133] = "TournGroup_MEGASTACK_Sanremo", _[_.TournGroup_MEGASTACK_Belgium = 134] = "TournGroup_MEGASTACK_Belgium", _[_.TournGroup_MEGASTACK_Namur = 135] = "TournGroup_MEGASTACK_Namur", _[_.TournGroup_Live_Satellites = 136] = "TournGroup_Live_Satellites", _[_.TournGroup_Promo1 = 137] = "TournGroup_Promo1", _[_.TournGroup_Promo2 = 138] = "TournGroup_Promo2", _[_.TournGroup_Promo3 = 139] = "TournGroup_Promo3", _[_.TournGroup_Promo4 = 140] = "TournGroup_Promo4", _[_.TournGroup_Promo5 = 141] = "TournGroup_Promo5", _[_.TournGroup_Promo6 = 142] = "TournGroup_Promo6", _[_.TournGroup_Promo7 = 143] = "TournGroup_Promo7", _[_.TournGroup_Promo8 = 144] = "TournGroup_Promo8", _[_.TournGroup_Promo9 = 145] = "TournGroup_Promo9", _[_.TournGroup_Promo10 = 146] = "TournGroup_Promo10", _[_.TournGroup_Wednesday_WTB = 147] = "TournGroup_Wednesday_WTB", _[_.TournGroup_Winter_Series = 148] = "TournGroup_Winter_Series", _[_.TournGroup_Summer_Series = 149] = "TournGroup_Summer_Series", _[_.TournGroup_PACOOP = 150] = "TournGroup_PACOOP", _[_.TournGroup_PASCOOP = 151] = "TournGroup_PASCOOP", _[_.TournGroup_sagpromo1 = 152] = "TournGroup_sagpromo1", _[_.TournGroup_sagpromo2 = 153] = "TournGroup_sagpromo2", _[_.TournGroup_sagpromo3 = 154] = "TournGroup_sagpromo3", _[_.TournGroup_sagpromo4 = 155] = "TournGroup_sagpromo4", _[_.TournGroup_sagpromo5 = 156] = "TournGroup_sagpromo5", _[_.TournGroup_sagpromo6 = 157] = "TournGroup_sagpromo6", _[_.TournGroup_sagpromo7 = 158] = "TournGroup_sagpromo7", _[_.TournGroup_sagpromo8 = 159] = "TournGroup_sagpromo8", _[_.TournGroup_sagpromo9 = 160] = "TournGroup_sagpromo9", _[_.TournGroup_sagpromo10 = 161] = "TournGroup_sagpromo10", _[_.TournGroup_lobbygroup1 = 162] = "TournGroup_lobbygroup1", _[_.TournGroup_lobbygroup2 = 163] = "TournGroup_lobbygroup2", _[_.TournGroup_lobbygroup3 = 164] = "TournGroup_lobbygroup3", _[_.TournGroup_lobbygroup4 = 165] = "TournGroup_lobbygroup4", _[_.TournGroup_lobbygroup5 = 166] = "TournGroup_lobbygroup5", _[_.TournGroup_lobbygroup6 = 167] = "TournGroup_lobbygroup6", _[_.TournGroup_lobbygroup7 = 168] = "TournGroup_lobbygroup7", _[_.TournGroup_lobbygroup8 = 169] = "TournGroup_lobbygroup8", _[_.TournGroup_lobbygroup9 = 170] = "TournGroup_lobbygroup9", _[_.TournGroup_lobbygroup10 = 171] = "TournGroup_lobbygroup10", _[_.TournGroup_HighRollers = 172] = "TournGroup_HighRollers", _[_.TournGroup_BountyBuilderSeries = 173] = "TournGroup_BountyBuilderSeries", _[_.TournGroup_CarnivalSeries = 174] = "TournGroup_CarnivalSeries", _[_.TournGroup_BSOP = 175] = "TournGroup_BSOP", _[_.TournGroup_APPTJeju = 176] = "TournGroup_APPTJeju", _[_.TournGroup_FreerollSeries = 177] = "TournGroup_FreerollSeries", _[_.TournGroup_Freeroll = 178] = "TournGroup_Freeroll", _[_.TournGroup_IMIN_Freeroll = 179] = "TournGroup_IMIN_Freeroll", _[_.TournGroup_Night_On_Stars = 180] = "TournGroup_Night_On_Stars", _[_.TournGroup_INCOOP = 181] = "TournGroup_INCOOP", _[_.TournGroup_INSCOOP = 182] = "TournGroup_INSCOOP", _[_.TournGroup_Stadium_Series = 183] = "TournGroup_Stadium_Series", _[_.TournGroup_Carnaval_Series = 184] = "TournGroup_Carnaval_Series", _[_.TournGroup_30_30 = 185] = "TournGroup_30_30", _[_.TournGroup_20_20 = 186] = "TournGroup_20_20", _[_.TournGroup_50_50 = 187] = "TournGroup_50_50", _[_.TournGroup_EPT_Online = 188] = "TournGroup_EPT_Online", _[_.TournGroup_Sunday_Majors = 189] = "TournGroup_Sunday_Majors", _[_.TournGroup_Saturday_Line_Up = 190] = "TournGroup_Saturday_Line_Up", _[_.TournGroup_Women_Event = 191] = "TournGroup_Women_Event", _[_.TournGroup_Blowout_Series = 192] = "TournGroup_Blowout_Series", _[_.TournGroup_MICOOP = 193] = "TournGroup_MICOOP", _[_.TournGroup_MISCOOP = 194] = "TournGroup_MISCOOP", _[_.TournGroup_TRIO_Series = 195] = "TournGroup_TRIO_Series", _[_.TournGroup_Football_Phase = 196] = "TournGroup_Football_Phase", _[_.TournGroup_KO_Sunday = 197] = "TournGroup_KO_Sunday", _[_.TournGroup_Sunday_Stackosaurus = 198] = "TournGroup_Sunday_Stackosaurus", _[_.TournGroup_Sunday_Brawl = 199] = "TournGroup_Sunday_Brawl", _[_.TournGroup_Sunday_Titan = 200] = "TournGroup_Sunday_Titan", _[_.TournGroup_Sunday_Rumble = 201] = "TournGroup_Sunday_Rumble", _[_.TournGroup_Saturday_Showdown = 202] = "TournGroup_Saturday_Showdown", _[_.TournGroup_CardsChat_Freeroll = 203] = "TournGroup_CardsChat_Freeroll", _[_.TournGroup_Women_Saturday_Heads_Up = 204] = "TournGroup_Women_Saturday_Heads_Up", _[_.TournGroup_PSPC = 205] = "TournGroup_PSPC", _[_.TournGroup_50_50_Series = 206] = "TournGroup_50_50_Series", _[_.TournGroup_Half_Price_Sunday = 207] = "TournGroup_Half_Price_Sunday", _[_.TournGroup_MicroMillions_Marathon = 208] = "TournGroup_MicroMillions_Marathon", _[_.TournGroup_Midstake_Madness = 209] = "TournGroup_Midstake_Madness", _[_.TournGroup_30_30_KO = 210] = "TournGroup_30_30_KO", _[_.TournGroup_Lex_Live = 211] = "TournGroup_Lex_Live", _[_.TournGroup_UKIPT = 212] = "TournGroup_UKIPT", _[_.TournGroup_MIWCOOP = 213] = "TournGroup_MIWCOOP", _[_.TournGroup_PAWCOOP = 214] = "TournGroup_PAWCOOP", _[_.TournGroup_NJWCOOP = 215] = "TournGroup_NJWCOOP", _[_.TournGroup_PRESEASON = 216] = "TournGroup_PRESEASON", _[_.TournGroup_Fall_Fest = 217] = "TournGroup_Fall_Fest", _[_.TournGroup_ONCOOP = 218] = "TournGroup_ONCOOP", _[_.TournGroup_Wednesday_Storm = 219] = "TournGroup_Wednesday_Storm", _[_.TournGroup_Friday_Night_Fight = 220] = "TournGroup_Friday_Night_Fight", _[_.TournGroup_Deepstack_Saturday = 221] = "TournGroup_Deepstack_Saturday", _[_.TournGroup_Sunday_Million_DE_Satellite = 222] = "TournGroup_Sunday_Million_DE_Satellite", _[_.TournGroup_Power_Path_Redeem = 223] = "TournGroup_Power_Path_Redeem", _[_.TournGroup_PATHSNG2 = 224] = "TournGroup_PATHSNG2", _[_.TournGroup_PATHMTT2 = 225] = "TournGroup_PATHMTT2", _[_.TournGroup_PATHMTT3 = 226] = "TournGroup_PATHMTT3", _[_.TournGroup_PATHMTT4 = 227] = "TournGroup_PATHMTT4", _[_.TournGroup_Mystery_Bounty = 228] = "TournGroup_Mystery_Bounty", _[_.TournGroup_NAPT_Vegas = 229] = "TournGroup_NAPT_Vegas", _[_.TournGroup_EPT_Cyprus = 230] = "TournGroup_EPT_Cyprus", _[_.TournGroup_Mid_Stakes_Madness = 231] = "TournGroup_Mid_Stakes_Madness", _[_.TournGroup_Summer_Week = 232] = "TournGroup_Summer_Week", _[_.TournGroup_Red_Spade_Pass = 233] = "TournGroup_Red_Spade_Pass", _[_.TournGroup_Summer_Festival = 234] = "TournGroup_Summer_Festival", _[_.TournGroup_Carnival = 235] = "TournGroup_Carnival", _[_.TournGroup_Irish_Open = 236] = "TournGroup_Irish_Open", _[_.TournGroup_EPT_Paris = 237] = "TournGroup_EPT_Paris", _[_.TournGroup_New_Year = 238] = "TournGroup_New_Year", _[_.TournGroup_Eureka = 239] = "TournGroup_Eureka", _[_.TournGroup_FPS = 240] = "TournGroup_FPS", _[_.TournGroup_EPT_London = 241] = "TournGroup_EPT_London", _[_.TournGroup_Eureka_Rozvadov = 242] = "TournGroup_Eureka_Rozvadov", _[_.TournGroup_Carnival_Series = 243] = "TournGroup_Carnival_Series", _[_.TournGroup_Seasons = 244] = "TournGroup_Seasons", _[_.TournGroup_FPS_Monte_Carlo = 245] = "TournGroup_FPS_Monte_Carlo", _[_.TournGroup_FPS_Paris = 246] = "TournGroup_FPS_Paris", _[_.TournGroup_25_Days_of_Tournaments = 247] = "TournGroup_25_Days_of_Tournaments", _[_.TournGroup_New_Year_Series = 248] = "TournGroup_New_Year_Series", _[_.TournGroup_FPS_Aix_En_Provence = 249] = "TournGroup_FPS_Aix_En_Provence", _[_.TournGroup_ESPT_Malaga = 250] = "TournGroup_ESPT_Malaga", _[_.TournGroup_ESPT_Barcelona = 251] = "TournGroup_ESPT_Barcelona", _[_.TournGroup_Eureka_Cyprus = 252] = "TournGroup_Eureka_Cyprus", _[_.TournGroup_Eureka_Prague = 253] = "TournGroup_Eureka_Prague", _.TournGroup_Last = "TournGroup_Eureka_Prague", _))(P || {}), M = /* @__PURE__ */ ((_) => (_[
  _["Daily Marathon"] = 1
  /* TournGroup_DailyMarathon */
] = "Daily Marathon", _[
  _["Daily 500"] = 2
  /* TournGroup_Daily500 */
] = "Daily 500", _[
  _.knockouts_poker = 3
  /* TournGroup_Knockouts */
] = "knockouts_poker", _[
  _.bounty_builder = 4
  /* TournGroup_BountyBuilders */
] = "bounty_builder", _[
  _["Bubble Rush"] = 5
  /* TournGroup_BubbleRush */
] = "Bubble Rush", _[
  _.fifty_50 = 6
  /* TournGroup_Fifty50 */
] = "fifty_50", _[
  _["Multi-Stack"] = 7
  /* TournGroup_MultiStack */
] = "Multi-Stack", _[
  _.Phased = 8
  /* TournGroup_Phased */
] = "Phased", _[
  _["Jumbo Shrimp"] = 9
  /* TournGroup_JumboShrimp */
] = "Jumbo Shrimp", _[
  _.shootout = 10
  /* TournGroup_Shootouts */
] = "shootout", _[
  _.Splash = 11
  /* TournGroup_Splash */
] = "Splash", _[
  _["Time Tourneys"] = 12
  /* TournGroup_TimeTourneys */
] = "Time Tourneys", _[
  _["Win the Button"] = 13
  /* TournGroup_WinTheButton */
] = "Win the Button", _[
  _["Triple Threat"] = 14
  /* TournGroup_TripleThreat */
] = "Triple Threat", _[
  _["Thursday Thrill"] = 15
  /* TournGroup_ThursdayThrill */
] = "Thursday Thrill", _[
  _["Fat Thursday"] = 16
  /* TournGroup_FatThursday */
] = "Fat Thursday", _[
  _["Super Tuesday"] = 17
  /* TournGroup_SuperTuesday */
] = "Super Tuesday", _[
  _["Fast Friday"] = 18
  /* TournGroup_FastFriday */
] = "Fast Friday", _[
  _["Double Duece"] = 19
  /* TournGroup_DoubleDuece */
] = "Double Duece", _[
  _["Turbo Series"] = 20
  /* TournGroup_TurboSeries */
] = "Turbo Series", _[
  _.Omania = 21
  /* TournGroup_Omania */
] = "Omania", _[
  _.hot_turbos = 22
  /* TournGroup_TheHotTurbos */
] = "hot_turbos", _[
  _.daily_bigs = 23
  /* TournGroup_TheDailyBigs */
] = "daily_bigs", _[
  _["Sunday Billion"] = 24
  /* TournGroup_SundayBillion */
] = "Sunday Billion", _[
  _["Sunday Million"] = 25
  /* TournGroup_SundayMillion */
] = "Sunday Million", _[
  _["Sunday Warm-Up"] = 26
  /* TournGroup_SundayWarmUp */
] = "Sunday Warm-Up", _[
  _["Sunday Storm"] = 27
  /* TournGroup_SundayStorm */
] = "Sunday Storm", _[
  _["Sunday Kickoff"] = 28
  /* TournGroup_SundayKickoff */
] = "Sunday Kickoff", _[
  _["Sunday Supersonic"] = 29
  /* TournGroup_SundaySupersonic */
] = "Sunday Supersonic", _[
  _["Sunday Showdown"] = 30
  /* TournGroup_SundayShowdown */
] = "Sunday Showdown", _[
  _["Saturday Micro"] = 31
  /* TournGroup_SaturdayMicro */
] = "Saturday Micro", _[
  _["Saturday Eliminator"] = 32
  /* TournGroup_SaturdayEliminator */
] = "Saturday Eliminator", _[
  _["Saturday Splash"] = 33
  /* TournGroup_SaturdaySplash */
] = "Saturday Splash", _[
  _.saturday_knockout = 34
  /* TournGroup_SaturdayKO */
] = "saturday_knockout", _[
  _["Saturday Duel"] = 35
  /* TournGroup_SaturdayDuel */
] = "Saturday Duel", _[
  _["Saturday Speedway"] = 36
  /* TournGroup_SaturdaySpeedway */
] = "Saturday Speedway", _[
  _.sunday_womens = 37
  /* TournGroup_WomensSunday */
] = "sunday_womens", _[
  _.WCOOP = 38
  /* TournGroup_WCOOP */
] = "WCOOP", _[
  _.SCOOP = 39
  /* TournGroup_SCOOP */
] = "SCOOP", _[
  _["Pacific Rim Special"] = 40
  /* TournGroup_PacificRimSpecial */
] = "Pacific Rim Special", _[
  _["Micro Madness"] = 41
  /* TournGroup_MicroMadness */
] = "Micro Madness", _[
  _["Saturday Slam"] = 42
  /* TournGroup_SaturdaySlam */
] = "Saturday Slam", _[
  _["Saturday Rebuy"] = 43
  /* TournGroup_SaturdayRebuy */
] = "Saturday Rebuy", _[
  _["Saturday Spider"] = 44
  /* TournGroup_SaturdaySpider */
] = "Saturday Spider", _[
  _["Saturday Scuffle"] = 45
  /* TournGroup_SaturdayScuffle */
] = "Saturday Scuffle", _[
  _["Sunday Starter"] = 46
  /* TournGroup_SundayStarter */
] = "Sunday Starter", _[
  _["Sunday Slam"] = 47
  /* TournGroup_SundaySlam */
] = "Sunday Slam", _[
  _["Sunday Marathon"] = 48
  /* TournGroup_SundayMarathon */
] = "Sunday Marathon", _[
  _["Sunday Rebuy"] = 49
  /* TournGroup_SundayRebuy */
] = "Sunday Rebuy", _[
  _["Sunday High Roller"] = 50
  /* TournGroup_SundayHighRoller */
] = "Sunday High Roller", _[
  _["Sunday 500"] = 51
  /* TournGroup_Sunday500 */
] = "Sunday 500", _[
  _["Sunday Stack"] = 52
  /* TournGroup_SundayStack */
] = "Sunday Stack", _[
  _["Sunday Cooldown"] = 53
  /* TournGroup_SundayCooldown */
] = "Sunday Cooldown", _[
  _["Sunday Wrap-Up"] = 54
  /* TournGroup_SundayWrapUp */
] = "Sunday Wrap-Up", _[
  _["Sunday Special"] = 55
  /* TournGroup_SundaySpecial */
] = "Sunday Special", _[
  _["Sunday HORSE"] = 56
  /* TournGroup_SundayHORSE */
] = "Sunday HORSE", _[
  _["High Roller Club"] = 57
  /* TournGroup_High_Roller_Club */
] = "High Roller Club", _[
  _.sunday_million_anniverary = 58
  /* TournGroup_Sunday_Million_Anniversary */
] = "sunday_million_anniverary", _[
  _["Sunday Storm Anniversary"] = 59
  /* TournGroup_Sunday_Storm_Anniversary */
] = "Sunday Storm Anniversary", _[
  _.MicroMillions = 60
  /* TournGroup_MicroMillions */
] = "MicroMillions", _[
  _["Battle Royale"] = 61
  /* TournGroup_Battle_Royale */
] = "Battle Royale", _[
  _["Monday 6-Max"] = 62
  /* TournGroup_Monday_6Max */
] = "Monday 6-Max", _[
  _["Fat Tuesday"] = 63
  /* TournGroup_Fat_Tuesday */
] = "Fat Tuesday", _[
  _["All In Shootout"] = 64
  /* TournGroup_All_In_Shootout */
] = "All In Shootout", _[
  _["Micro Series"] = 65
  /* TournGroup_Micro_Series */
] = "Micro Series", _[
  _.SECOOP = 66
  /* TournGroup_SECOOP */
] = "SECOOP", _[
  _.NJSCOOP = 67
  /* TournGroup_NJSCOOP */
] = "NJSCOOP", _[
  _.NJCOOP = 68
  /* TournGroup_NJCOOP */
] = "NJCOOP", _[
  _.ICOOP = 69
  /* TournGroup_ICOOP */
] = "ICOOP", _[
  _["KO Fever"] = 70
  /* TournGroup_KO_Fever */
] = "KO Fever", _[
  _["Nightly Stars"] = 71
  /* TournGroup_Nightly_Stars */
] = "Nightly Stars", _[
  _["Change Up"] = 72
  /* TournGroup_Change_Up */
] = "Change Up", _[
  _["Moonlight Express"] = 73
  /* TournGroup_Moonlight_Express */
] = "Moonlight Express", _[
  _["Galactic Series"] = 74
  /* TournGroup_Galactic_Series */
] = "Galactic Series", _[
  _["Sunday Storm Rebuy"] = 75
  /* TournGroup_Sunday_Storm_Rebuy */
] = "Sunday Storm Rebuy", _[
  _["The Storm Rebuy"] = 76
  /* TournGroup_The_Storm_Rebuy */
] = "The Storm Rebuy", _[
  _["Super Thursday Storm"] = 77
  /* TournGroup_Super_Thursday_Storm */
] = "Super Thursday Storm", _[
  _.SuperStack = 78
  /* TournGroup_SuperStack */
] = "SuperStack", _[
  _.Jab = 79
  /* TournGroup_Jab */
] = "Jab", _[
  _.Hook = 80
  /* TournGroup_Hook */
] = "Hook", _[
  _.Uppercut = 81
  /* TournGroup_Uppercut */
] = "Uppercut", _[
  _["Ultra KO"] = 82
  /* TournGroup_Ultra_KO */
] = "Ultra KO", _[
  _["Afternoon on Stars"] = 83
  /* TournGroup_Afternoon_on_Stars */
] = "Afternoon on Stars", _[
  _["El Clasico"] = 84
  /* TournGroup_El_Clasico */
] = "El Clasico", _[
  _["O Clasico"] = 85
  /* TournGroup_O_Clasico */
] = "O Clasico", _[
  _["Super Thursday"] = 86
  /* TournGroup_Super_Thursday */
] = "Super Thursday", _[
  _["Super Thursday Uppercut"] = 87
  /* TournGroup_Super_Thursday_Uppercut */
] = "Super Thursday Uppercut", _[
  _["Super Thursday Bigger"] = 88
  /* TournGroup_Super_Thursday_Bigger */
] = "Super Thursday Bigger", _[
  _["Super Thursday Night on Stars"] = 89
  /* TournGroup_Super_Thursday_Night_on_Stars */
] = "Super Thursday Night on Stars", _[
  _["Super Thursday 6th Sense"] = 90
  /* TournGroup_Super_Thursday_6th_Sense */
] = "Super Thursday 6th Sense", _[
  _.super_thursday_bigstack_turbo = 91
  /* TournGroup_Super_Thursday_Hot_BigStack_Turbo */
] = "super_thursday_bigstack_turbo", _[
  _["Super Thursday Omaha"] = 92
  /* TournGroup_Super_Thursday_Omaha */
] = "Super Thursday Omaha", _[
  _["Super Thursday Midnight Express"] = 93
  /* TournGroup_Super_Thursday_Midnight_Express */
] = "Super Thursday Midnight Express", _[
  _["Super Monday"] = 94
  /* TournGroup_Super_Monday */
] = "Super Monday", _[
  _["Super Monday Uppercut"] = 95
  /* TournGroup_Super_Monday_Uppercut */
] = "Super Monday Uppercut", _[
  _["Super Monday Bigger"] = 96
  /* TournGroup_Super_Monday_Bigger */
] = "Super Monday Bigger", _[
  _["Super Monday Night on Stars"] = 97
  /* TournGroup_Super_Monday_Night_on_Stars */
] = "Super Monday Night on Stars", _[
  _["Super Monday 6th Sense"] = 98
  /* TournGroup_Super_Monday_6th_Sense */
] = "Super Monday 6th Sense", _[
  _.super_monday_bigstack_turbo = 99
  /* TournGroup_Super_Monday_Hot_BigStack_Turbo */
] = "super_monday_bigstack_turbo", _[
  _["Super Monday Omaha"] = 100
  /* TournGroup_Super_Monday_Omaha */
] = "Super Monday Omaha", _[
  _["Super Monday Midnight Express"] = 101
  /* TournGroup_Super_Monday_Midnight_Express */
] = "Super Monday Midnight Express", _[
  _["Sunday 6-Max"] = 102
  /* TournGroup_Sunday_6Max */
] = "Sunday 6-Max", _[
  _["Sunday Omaha HiLo"] = 103
  /* TournGroup_Sunday_Omaha_HiLo */
] = "Sunday Omaha HiLo", _[
  _["Sunday Omaha"] = 104
  /* TournGroup_Sunday_Omaha */
] = "Sunday Omaha", _[
  _["Sunday Evening"] = 105
  /* TournGroup_Sunday_Evening */
] = "Sunday Evening", _[
  _["Sunday Full KO"] = 106
  /* TournGroup_Sunday_Full_KO */
] = "Sunday Full KO", _[
  _["Sunday Special Knockout"] = 107
  /* TournGroup_Sunday_Special_Knockout */
] = "Sunday Special Knockout", _[
  _["Sunday Challenge"] = 108
  /* TournGroup_Sunday_Challenge */
] = "Sunday Challenge", _[
  _["Sunday Micro"] = 109
  /* TournGroup_Sunday_Micro */
] = "Sunday Micro", _[
  _["Sunday Zoom"] = 110
  /* TournGroup_Sunday_Zoom */
] = "Sunday Zoom", _[
  _["Sunday Mini"] = 111
  /* TournGroup_Sunday_Mini */
] = "Sunday Mini", _[
  _["6-Max Club"] = 112
  /* TournGroup_6Max_Club */
] = "6-Max Club", _[
  _["Full KO"] = 113
  /* TournGroup_Full_KO */
] = "Full KO", _[
  _.EPT = 114
  /* TournGroup_EPT */
] = "EPT", _[
  _["EPT Prague"] = 115
  /* TournGroup_EPT_Prague */
] = "EPT Prague", _[
  _["EPT Sochi"] = 116
  /* TournGroup_EPT_Sochi */
] = "EPT Sochi", _[
  _["EPT Monte Carlo"] = 117
  /* TournGroup_EPT_Monte_Carlo */
] = "EPT Monte Carlo", _[
  _["EPT Barcelona"] = 118
  /* TournGroup_EPT_Barcelona */
] = "EPT Barcelona", _[
  _.PCA = 119
  /* TournGroup_PCA */
] = "PCA", _[
  _["Macau Poker Cup"] = 120
  /* TournGroup_Macau_Poker_Cup */
] = "Macau Poker Cup", _[
  _.APPT = 121
  /* TournGroup_APPT */
] = "APPT", _[
  _["APPT Manila"] = 122
  /* TournGroup_APPT_Manila */
] = "APPT Manila", _[
  _["APPT Macau"] = 123
  /* TournGroup_APPT_Macau */
] = "APPT Macau", _[
  _["APPT Korea"] = 124
  /* TournGroup_APPT_Korea */
] = "APPT Korea", _[
  _["PokerStars MEGASTACK"] = 125
  /* TournGroup_PokerStars_MEGASTACK */
] = "PokerStars MEGASTACK", _[
  _["MEGASTACK UK & Ireland"] = 126
  /* TournGroup_MEGASTACK_UK_Ireland */
] = "MEGASTACK UK & Ireland", _[
  _["MEGASTACK London"] = 127
  /* TournGroup_MEGASTACK_London */
] = "MEGASTACK London", _[
  _["MEGASTACK Dublin"] = 128
  /* TournGroup_MEGASTACK_Dublin */
] = "MEGASTACK Dublin", _[
  _["MEGASTACK France"] = 129
  /* TournGroup_MEGASTACK_France */
] = "MEGASTACK France", _[
  _["MEGASTACK Gujan-Mestras"] = 130
  /* TournGroup_MEGASTACK_GujanMestras */
] = "MEGASTACK Gujan-Mestras", _[
  _["MEGASTACK Le Grande Motte"] = 131
  /* TournGroup_MEGASTACK_Le_Grande_Motte */
] = "MEGASTACK Le Grande Motte", _[
  _["MEGASTACK Italy"] = 132
  /* TournGroup_MEGASTACK_Italy */
] = "MEGASTACK Italy", _[
  _["MEGASTACK Sanremo"] = 133
  /* TournGroup_MEGASTACK_Sanremo */
] = "MEGASTACK Sanremo", _[
  _["MEGASTACK Belgium"] = 134
  /* TournGroup_MEGASTACK_Belgium */
] = "MEGASTACK Belgium", _[
  _["MEGASTACK Namur"] = 135
  /* TournGroup_MEGASTACK_Namur */
] = "MEGASTACK Namur", _[
  _["Live Satellites"] = 136
  /* TournGroup_Live_Satellites */
] = "Live Satellites", _[
  _.Promo1 = 137
  /* TournGroup_Promo1 */
] = "Promo1", _[
  _.Promo2 = 138
  /* TournGroup_Promo2 */
] = "Promo2", _[
  _.Promo3 = 139
  /* TournGroup_Promo3 */
] = "Promo3", _[
  _.Promo4 = 140
  /* TournGroup_Promo4 */
] = "Promo4", _[
  _.Promo5 = 141
  /* TournGroup_Promo5 */
] = "Promo5", _[
  _.Promo6 = 142
  /* TournGroup_Promo6 */
] = "Promo6", _[
  _.Promo7 = 143
  /* TournGroup_Promo7 */
] = "Promo7", _[
  _.Promo8 = 144
  /* TournGroup_Promo8 */
] = "Promo8", _[
  _.Promo9 = 145
  /* TournGroup_Promo9 */
] = "Promo9", _[
  _.Promo10 = 146
  /* TournGroup_Promo10 */
] = "Promo10", _[
  _["Wednesday WTB"] = 147
  /* TournGroup_Wednesday_WTB */
] = "Wednesday WTB", _[
  _["Winter Series"] = 148
  /* TournGroup_Winter_Series */
] = "Winter Series", _[
  _["Summer Series"] = 149
  /* TournGroup_Summer_Series */
] = "Summer Series", _[
  _.PACOOP = 150
  /* TournGroup_PACOOP */
] = "PACOOP", _[
  _.PASCOOP = 151
  /* TournGroup_PASCOOP */
] = "PASCOOP", _[
  _.sagpromo1 = 152
  /* TournGroup_sagpromo1 */
] = "sagpromo1", _[
  _.sagpromo2 = 153
  /* TournGroup_sagpromo2 */
] = "sagpromo2", _[
  _.sagpromo3 = 154
  /* TournGroup_sagpromo3 */
] = "sagpromo3", _[
  _.sagpromo4 = 155
  /* TournGroup_sagpromo4 */
] = "sagpromo4", _[
  _.sagpromo5_sag = 156
  /* TournGroup_sagpromo5 */
] = "sagpromo5_sag", _[
  _.sagpromo6 = 157
  /* TournGroup_sagpromo6 */
] = "sagpromo6", _[
  _.sagpromo7 = 158
  /* TournGroup_sagpromo7 */
] = "sagpromo7", _[
  _.sagpromo8 = 159
  /* TournGroup_sagpromo8 */
] = "sagpromo8", _[
  _.sagpromo9 = 160
  /* TournGroup_sagpromo9 */
] = "sagpromo9", _[
  _.sagpromo10 = 161
  /* TournGroup_sagpromo10 */
] = "sagpromo10", _[
  _.lobbygroup1 = 162
  /* TournGroup_lobbygroup1 */
] = "lobbygroup1", _[
  _.lobbygroup2 = 163
  /* TournGroup_lobbygroup2 */
] = "lobbygroup2", _[
  _.lobbygroup3 = 164
  /* TournGroup_lobbygroup3 */
] = "lobbygroup3", _[
  _.lobbygroup4 = 165
  /* TournGroup_lobbygroup4 */
] = "lobbygroup4", _[
  _.lobbygroup5 = 166
  /* TournGroup_lobbygroup5 */
] = "lobbygroup5", _[
  _.lobbygroup6 = 167
  /* TournGroup_lobbygroup6 */
] = "lobbygroup6", _[
  _.lobbygroup7 = 168
  /* TournGroup_lobbygroup7 */
] = "lobbygroup7", _[
  _.lobbygroup8 = 169
  /* TournGroup_lobbygroup8 */
] = "lobbygroup8", _[
  _.lobbygroup9 = 170
  /* TournGroup_lobbygroup9 */
] = "lobbygroup9", _[
  _.lobbygroup10 = 171
  /* TournGroup_lobbygroup10 */
] = "lobbygroup10", _[
  _["High Rollers"] = 172
  /* TournGroup_HighRollers */
] = "High Rollers", _[
  _["Bounty Builder Series"] = 173
  /* TournGroup_BountyBuilderSeries */
] = "Bounty Builder Series", _[
  _["Carnival Series"] = 174
  /* TournGroup_CarnivalSeries */
] = "Carnival Series", _[
  _.BSOP = 175
  /* TournGroup_BSOP */
] = "BSOP", _[
  _["APPT Jeju"] = 176
  /* TournGroup_APPTJeju */
] = "APPT Jeju", _[
  _["Freeroll Series"] = 177
  /* TournGroup_FreerollSeries */
] = "Freeroll Series", _[
  _.Freeroll = 178
  /* TournGroup_Freeroll */
] = "Freeroll", _[
  _["IMIN Freeroll"] = 179
  /* TournGroup_IMIN_Freeroll */
] = "IMIN Freeroll", _[
  _["Night On Stars"] = 180
  /* TournGroup_Night_On_Stars */
] = "Night On Stars", _[
  _.INCOOP = 181
  /* TournGroup_INCOOP */
] = "INCOOP", _[
  _.INSCOOP = 182
  /* TournGroup_INSCOOP */
] = "INSCOOP", _[
  _["Stadium Series"] = 183
  /* TournGroup_Stadium_Series */
] = "Stadium Series", _[
  _["Carnaval Series"] = 184
  /* TournGroup_Carnaval_Series */
] = "Carnaval Series", _[
  _["30 30"] = 185
  /* TournGroup_30_30 */
] = "30 30", _[
  _["20 20"] = 186
  /* TournGroup_20_20 */
] = "20 20", _[
  _["50 50"] = 187
  /* TournGroup_50_50 */
] = "50 50", _[
  _["EPT Online"] = 188
  /* TournGroup_EPT_Online */
] = "EPT Online", _[
  _["Sunday Majors"] = 189
  /* TournGroup_Sunday_Majors */
] = "Sunday Majors", _[
  _["Saturday Line Up"] = 190
  /* TournGroup_Saturday_Line_Up */
] = "Saturday Line Up", _[
  _["Women Event"] = 191
  /* TournGroup_Women_Event */
] = "Women Event", _[
  _["Blowout Series"] = 192
  /* TournGroup_Blowout_Series */
] = "Blowout Series", _[
  _.MICOOP = 193
  /* TournGroup_MICOOP */
] = "MICOOP", _[
  _.MISCOOP = 194
  /* TournGroup_MISCOOP */
] = "MISCOOP", _[
  _["TRIO Series"] = 195
  /* TournGroup_TRIO_Series */
] = "TRIO Series", _[
  _["Football Phase"] = 196
  /* TournGroup_Football_Phase */
] = "Football Phase", _[
  _["KO Sunday"] = 197
  /* TournGroup_KO_Sunday */
] = "KO Sunday", _[
  _["Sunday Stackosaurus"] = 198
  /* TournGroup_Sunday_Stackosaurus */
] = "Sunday Stackosaurus", _[
  _["Sunday Brawl"] = 199
  /* TournGroup_Sunday_Brawl */
] = "Sunday Brawl", _[
  _["Sunday Titan"] = 200
  /* TournGroup_Sunday_Titan */
] = "Sunday Titan", _[
  _["Sunday Rumble"] = 201
  /* TournGroup_Sunday_Rumble */
] = "Sunday Rumble", _[
  _["Saturday Showdown"] = 202
  /* TournGroup_Saturday_Showdown */
] = "Saturday Showdown", _[
  _["CardsChat Freeroll"] = 203
  /* TournGroup_CardsChat_Freeroll */
] = "CardsChat Freeroll", _[
  _["Women Saturday Heads Up"] = 204
  /* TournGroup_Women_Saturday_Heads_Up */
] = "Women Saturday Heads Up", _[
  _.PSPC = 205
  /* TournGroup_PSPC */
] = "PSPC", _[
  _["50 50 Series"] = 206
  /* TournGroup_50_50_Series */
] = "50 50 Series", _[
  _["Half Price Sunday"] = 207
  /* TournGroup_Half_Price_Sunday */
] = "Half Price Sunday", _[
  _["MicroMillions Marathon"] = 208
  /* TournGroup_MicroMillions_Marathon */
] = "MicroMillions Marathon", _[
  _["Midstake Madness"] = 209
  /* TournGroup_Midstake_Madness */
] = "Midstake Madness", _[
  _["30 30 KO"] = 210
  /* TournGroup_30_30_KO */
] = "30 30 KO", _[
  _["Lex Live"] = 211
  /* TournGroup_Lex_Live */
] = "Lex Live", _[
  _.UKIPT = 212
  /* TournGroup_UKIPT */
] = "UKIPT", _[
  _.MIWCOOP = 213
  /* TournGroup_MIWCOOP */
] = "MIWCOOP", _[
  _.PAWCOOP = 214
  /* TournGroup_PAWCOOP */
] = "PAWCOOP", _[
  _.NJWCOOP = 215
  /* TournGroup_NJWCOOP */
] = "NJWCOOP", _[
  _.PRESEASON = 216
  /* TournGroup_PRESEASON */
] = "PRESEASON", _[
  _.Fall_Fest = 217
  /* TournGroup_Fall_Fest */
] = "Fall_Fest", _[
  _.ONCOOP = 218
  /* TournGroup_ONCOOP */
] = "ONCOOP", _[
  _["Wednesday Storm"] = 219
  /* TournGroup_Wednesday_Storm */
] = "Wednesday Storm", _[
  _["Friday Night Fight"] = 220
  /* TournGroup_Friday_Night_Fight */
] = "Friday Night Fight", _[
  _["Deepstack Saturday"] = 221
  /* TournGroup_Deepstack_Saturday */
] = "Deepstack Saturday", _[
  _["Sunday Million DE Satellite"] = 222
  /* TournGroup_Sunday_Million_DE_Satellite */
] = "Sunday Million DE Satellite", _[
  _["Power Path Redeem"] = 223
  /* TournGroup_Power_Path_Redeem */
] = "Power Path Redeem", _[
  _.PATHSNG2 = 224
  /* TournGroup_PATHSNG2 */
] = "PATHSNG2", _[
  _.PATHMTT2 = 225
  /* TournGroup_PATHMTT2 */
] = "PATHMTT2", _[
  _.PATHMTT3 = 226
  /* TournGroup_PATHMTT3 */
] = "PATHMTT3", _[
  _.PATHMTT4 = 227
  /* TournGroup_PATHMTT4 */
] = "PATHMTT4", _[
  _["Mystery Bounty"] = 228
  /* TournGroup_Mystery_Bounty */
] = "Mystery Bounty", _[
  _["NAPT Vegas"] = 229
  /* TournGroup_NAPT_Vegas */
] = "NAPT Vegas", _[
  _["EPT Cyprus"] = 230
  /* TournGroup_EPT_Cyprus */
] = "EPT Cyprus", _[
  _["Mid Stakes Madness"] = 231
  /* TournGroup_Mid_Stakes_Madness */
] = "Mid Stakes Madness", _[
  _["Summer Week"] = 232
  /* TournGroup_Summer_Week */
] = "Summer Week", _[
  _["Red Spade Pass"] = 233
  /* TournGroup_Red_Spade_Pass */
] = "Red Spade Pass", _[
  _["Summer Festival"] = 234
  /* TournGroup_Summer_Festival */
] = "Summer Festival", _[
  _.Carnival = 235
  /* TournGroup_Carnival */
] = "Carnival", _[
  _["Irish Open"] = 236
  /* TournGroup_Irish_Open */
] = "Irish Open", _[
  _["EPT Paris"] = 237
  /* TournGroup_EPT_Paris */
] = "EPT Paris", _[
  _["New Year"] = 238
  /* TournGroup_New_Year */
] = "New Year", _[
  _.Eureka = 239
  /* TournGroup_Eureka */
] = "Eureka", _[
  _.FPS = 240
  /* TournGroup_FPS */
] = "FPS", _[
  _["EPT London"] = 241
  /* TournGroup_EPT_London */
] = "EPT London", _[
  _["Eureka Rozvadov"] = 242
  /* TournGroup_Eureka_Rozvadov */
] = "Eureka Rozvadov", _[
  _.CarnivalSeries = 243
  /* TournGroup_Carnival_Series */
] = "CarnivalSeries", _[
  _.Seasons = 244
  /* TournGroup_Seasons */
] = "Seasons", _[
  _["FPS Monte Carlo"] = 245
  /* TournGroup_FPS_Monte_Carlo */
] = "FPS Monte Carlo", _[
  _["FPS Paris"] = 246
  /* TournGroup_FPS_Paris */
] = "FPS Paris", _[
  _["25 Days of Tournaments"] = 247
  /* TournGroup_25_Days_of_Tournaments */
] = "25 Days of Tournaments", _[
  _["New Year Series"] = 248
  /* TournGroup_New_Year_Series */
] = "New Year Series", _[
  _["FPS Aix En Provence"] = 249
  /* TournGroup_FPS_Aix_En_Provence */
] = "FPS Aix En Provence", _[
  _["ESPT Malaga"] = 250
  /* TournGroup_ESPT_Malaga */
] = "ESPT Malaga", _[
  _["ESPT Barcelona"] = 251
  /* TournGroup_ESPT_Barcelona */
] = "ESPT Barcelona", _[
  _["Eureka Cyprus"] = 252
  /* TournGroup_Eureka_Cyprus */
] = "Eureka Cyprus", _[
  _["Eureka Prague"] = 253
  /* TournGroup_Eureka_Prague */
] = "Eureka Prague", _))(M || {}), h = /* @__PURE__ */ ((_) => (_.CASH_GAMES_ENTRY = "cash-games-entry", _))(h || {}), O = /* @__PURE__ */ ((_) => (_.CASH_GAMES = "cash-games", _.CONTENTSTACK = "contentstack", _))(O || {}), g = /* @__PURE__ */ ((_) => (_[_.NonDefined = 0] = "NonDefined", _[_.L = 1] = "L", _[_.PL = 2] = "PL", _[_.NL = 3] = "NL", _[_.PNL = 4] = "PNL", _))(g || {});
const K = {
  0: "None",
  1: "Badugi",
  2: "Holdem",
  3: "5 Omaha",
  4: "Omaha",
  5: "Draw",
  6: "Single Draw 27",
  7: "Stud",
  8: "Razz",
  9: "3 Draw 27",
  10: "3 Draw A5",
  11: "Courchevel",
  12: "6 Omaha",
  13: "Split Holdem",
  14: "Split Omaha",
  15: "Showtime Holdem",
  16: "Showtime Omaha",
  17: "Fusion",
  18: "Unfold Classic",
  19: "Unfold Max",
  20: "6+ Holdem",
  21: "Deep Water Holdem",
  22: "Deep Water Omaha",
  23: "Swap Holdem",
  24: "All-In Poker",
  25: "",
  // undefined
  100: "Hose",
  101: "Horse",
  102: "Nl 8-Game",
  103: "Mixed Holdem",
  104: "Mixed Omaha Hl",
  105: "Pl Holdem Pl Omaha",
  106: "Nl Triple Stud",
  107: "Nl Holdem Pl Omaha",
  108: "Nl Mixed Omaha"
};
var A = /* @__PURE__ */ ((_) => (_.ArgentinePeso = "ARS", _.AustralianDollar = "AUD", _.BelarusianRuble = "BYR", _.BrazilianReal = "BRL", _.BritishPound = "GBP", _.BulgarianLev = "BGN", _.CanadianDollar = "CAD", _.ChileanPeso = "CLP", _.ChineseYuan = "CNY", _.ColombianPeso = "COP", _.CroatianKuna = "HRK", _.CzechKoruna = "CZK", _.DanishKrone = "DKK", _.EstonianKroon = "EEK", _.Euro = "EUR", _.HungarianForint = "HUF", _.IcelandicKrona = "ISK", _.IndianRupee = "INR", _.JapaneseYen = "JPY", _.KazakhstaniTenge = "KZT", _.LatvianLats = "LVL", _.LithuanianLitas = "LTL", _.MexicanPeso = "MXN", _.MoldovanLeu = "MDL", _.MongolianTugrik = "MNT", _.NewTaiwanDollar = "TWD", _.NewZealandDollar = "NZD", _.NorwegianKrone = "NOK", _.ParaguayanGuarani = "PYG", _.PeruvianSol = "PEN", _.PhilippinePeso = "PHP", _.PlayMoney = "PFF", _.PolishZloty = "PLN", _.RomanianLeu = "RON", _.RussianRuble = "RUB", _.SerbianDinar = "RSD", _.SlovakKoruna = "SKK", _.SouthAfricanRand = "ZAR", _.SwedishKrona = "SEK", _.SwissFranc = "CHF", _.ThaiBaht = "THB", _.USDollar = "USD", _.UkrainianHryvnia = "UAH", _.UruguayanPeso = "UYU", _))(A || {});
const R = {
  4: "USD",
  8: "EUR",
  16: "GBP",
  32: "CAD"
  /* CanadianDollar */
};
export {
  h as CacheKey,
  O as CacheTag,
  i as Cookie,
  A as Currency,
  R as CurrencyByInt,
  d as Header,
  l as MessageIds,
  t as ResolverTag,
  g as Structure,
  C as ThemeSchema,
  c as ThemeVariantSchema,
  M as TournGroupName,
  P as TournGroupTypes,
  K as legacyHandTypeToAssetNameMap
};
//# sourceMappingURL=index.mjs.map
